module.exports = __webpack_public_path__ + "static/media/file-simple-icon.67d2d110.svg";